import { LobbyMessage, LobbyMessageType, PlayerLobbyStatus } from '@playcastdotio/Messaging';
import { lobbyState, lobbyQueryState } from '../../../stores/lobbyStores';
import { invitationState } from '../../../stores/lobbyStores';
import { playerConnectionState } from '../../../stores/playerStores';

export const handleLobbyMessage = (message: LobbyMessage) => {
  switch (message.type) {
    case LobbyMessageType.LOBBY_STATE_CHANGED: {
      console.log('Lobby message:', message);
      const me = message?.players?.find((player) => player.playerId === invitationState.currentState.invitationPlayerId);
      if (me) {
        lobbyState.updateState({
          ...lobbyState.currentState,
          accepted: me.status === PlayerLobbyStatus.Accepted,
          position: me.position,
        });
      }
      lobbyState.updateState({
        ...lobbyState.currentState,
        ...message,
      });
      break;
    }
    case LobbyMessageType.LOBBY_QUERY_RESPONSE: {
      console.log('Lobby query response:', message);
      // Update the lobby query state with the response
      lobbyQueryState.updateState({
        ...lobbyQueryState.currentState,
        [message.invitationId]: {
          players: message.players,
          connectedPlayerCount: message.connectedPlayerCount,
          lastUpdated: Date.now(),
        },
      });
      break;
    }
    case LobbyMessageType.LOBBY_ACCEPT_SUCCESS: {
      console.log('Lobby message:', message);
      lobbyState.updateState({
        ...lobbyState.currentState,
        accepted: true,
        broadcastHostId: message.hostPeerId,
        lobbyPlayerId: message.playerId,
      });
      playerConnectionState.updateState({
        ...playerConnectionState.currentState,
        broadcastSessionId: message.hostPeerId,
      });
      break;
    }
    case LobbyMessageType.LOBBY_ACCEPT_ERROR: {
      console.log('Lobby message:', message);
      break;
    }
    case LobbyMessageType.LOBBY_LEAVE_SUCCESS: {
      console.log('Lobby message:', message);
      break;
    }
    case LobbyMessageType.LOBBY_ACCEPT:
    case LobbyMessageType.LOBBY_KICK:
    case LobbyMessageType.LOBBY_KICK_SUCCESS:
    case LobbyMessageType.LOBBY_LEAVE:
    case LobbyMessageType.LOBBY_REORDER:
    case LobbyMessageType.LOBBY_REORDER_SUCCESS:
    case LobbyMessageType.LOBBY_QUERY: {
      console.log('Lobby message:', message);
      break;
    }
  }
};
